module.exports = __webpack_public_path__ + "img/checklist.3f5b8a47.svg";